import React from 'react'
import { Button, Flex, Modal, Text } from '@workwhile/ui'

type IgnoreConfirmModalProps = {
  open: boolean
  selectedCount: number
  isPending: boolean
  onClose: () => void
  onConfirm: () => void
}

export const IgnoreConfirmModal = ({
  open,
  selectedCount,
  isPending,
  onClose,
  onConfirm,
}: IgnoreConfirmModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Text fontWeight={600} mb={2}>
        Ignore selected punches?
      </Text>
      <Text mb={3}>
        This will mark {selectedCount} punch
        {selectedCount === 1 ? '' : 'es'} as ignored.{' '}
        {selectedCount === 1 ? 'It' : 'They'} will leave this list and will not
        be processed anymore.
      </Text>
      <Flex gap={2}>
        <Button variant="primary" disabled={isPending} onClick={onConfirm}>
          {isPending ? 'Ignoring…' : 'Confirm'}
        </Button>
        <Button variant="secondary" disabled={isPending} onClick={onClose}>
          Cancel
        </Button>
      </Flex>
    </Modal>
  )
}
